import { Helmet } from 'react-helmet-async';
import DishListView from 'src/sections/dish/view/dish-list-view';

export default function DishListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Lista de Pratos</title>
      </Helmet>

      <DishListView />
    </>
  );
}
